import React from 'react';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useIntl } from 'react-intl';

import { membershipTypeMessages } from 'src/features/membershipType/utils/messages';
import { MembershipType } from 'src/features/membershipType/types';
import ConfirmationModal from 'src/registry/components/blocks/ConfirmationModal';
import { DataTableNewEntryProps } from 'src/registry/components/table';
import { ICON_MAP } from 'src/utils/constants';
import { useParking } from 'src/providers/ParkingProvider';

interface ActivateMembershipTemplateProps<TData> extends DataTableNewEntryProps<TData> {
    selectedTemplate?: MembershipType;
    activateTemplate: ({ parkingId, is_active, id }: { parkingId: string; id: string; is_active: boolean }) => void;
    children?: React.ReactNode;
}

function ActivateMembershipType<TData>({
    selectedTemplate,
    activateTemplate,
    children,
}: ActivateMembershipTemplateProps<TData>) {
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const { locale } = useIntl();
    const { parkingId} = useParking();
    if (!selectedTemplate) return null;

    return (
        <ConfirmationModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            dialogDetails={{
                title: { ...membershipTypeMessages.activateTemplateModal },
                subTitle: {
                    ...membershipTypeMessages.activateTemplateSubtitle,
                    values: {
                        entry: selectedTemplate.translations?.find((temp) => temp.language === locale)?.name ?? '-',
                    },
                },
                icon: ICON_MAP.WAVE_PULSE as IconProp,
                confirmationMessage: {
                    ...membershipTypeMessages.confirmActivateTemplate,
                    values: {
                        entry: selectedTemplate.translations?.find((temp) => temp.language === locale)?.name ?? '-',
                    },
                },
            }}
            callbackButton={{
                variant: 'default',
                buttonTitle: membershipTypeMessages.activateTemplate,
                callbackFn: () => {
                    if (selectedTemplate) {
                        return (
                            activateTemplate({ parkingId, is_active: true, id: selectedTemplate.id || '' }),
                            setIsModalOpen(false)
                        );
                    }
                },
            }}
        >
            {children}
        </ConfirmationModal>
    );
}

export default ActivateMembershipType;
